// import HistoryTool from '../Utilities/HistoryTool';
import { useEffect } from 'react';
import Profile from '../Utilities/Profile';
import AlignmentTool from './AlignmentTool';
import BackgroundTool from './BackgroundTool';
import BlockquoteTool from './BlockquoteTool';
import BoldTool from './BoldTool';
import ClearTool from './ClearTool';
import CodeBlockTool from './CodeBlockTool';
import CodeTool from './CodeTool';
import ColorTool from './ColorTool';
// import CommentTool from './CommentTool';
import DecreaseIndentTool from './DecreaseIndentTool';
import FontTool from './FontTool';
import ImageTool from './ImageTool';
import IncreaseIndentTool from './IncreaseIndentTool';
import ItalicTool from './ItalicTool';
import LinkToolbar from './LinkToolbar';
import OrderedListTool from './OrderedListTool';
import RedoTool from './RedoTool';
import SizeTool from './SizeTool';
import StrikeTool from './StrikeTool';
import TableTool from './TableTool';
// import TemplateTool from './TemplateTool';
import debounce from 'lodash/debounce';
import { useDispatch } from 'react-redux';
import {
    setBlotDetails,
    setBlotLinkAnchorEl,
    setColorPickerBackgroundColor,
    setColorPickerColor,
    setIsBold,
    setIsCodeBlock,
    setIsItalic,
    setIsOrderedList,
    setIsStrike,
    setIsUnderline,
    setIsUnorderedList,
    setSelectedAlignment,
    setSelectedBackgroundColor,
    setSelectedColor,
    setSelectedFont,
    setSelectedSize,
} from 'store/actions/editorActions';
import { ptToPx } from '../utils/fns';
import UnderlineTool from './UnderlineTool';
import UndoTool from './UndoTool';
import UnorderedListTool from './UnorderedListTool';

export default function CustomToolbar({ editorRef, isEditable, document, isTemplateFile }) {
    const dispatch = useDispatch();

    useEffect(() => {
        if (editorRef.current) {
            const quill = editorRef.current;

            // eslint-disable-next-line no-inner-declarations
            function handleSelectionChange(range) {
                if (!quill.hasFocus()) return;

                const format = quill.getFormat();

                if (format['align']) {
                    dispatch(setSelectedAlignment(format['align']));
                } else {
                    dispatch(setSelectedAlignment('left'));
                }

                if (format['background']) {
                    dispatch(setSelectedBackgroundColor(format['background']));
                    dispatch(setColorPickerBackgroundColor(format['background']));
                } else {
                    dispatch(setSelectedBackgroundColor('#ffffff'));
                    dispatch(setColorPickerBackgroundColor('#ffffff'));
                }

                if (format['bold']) {
                    dispatch(setIsBold(true));
                } else {
                    dispatch(setIsBold(false));
                }

                dispatch(setIsCodeBlock(!!format['code-block']));

                dispatch(setIsCodeBlock(!!format['code']));

                if (format['color']) {
                    dispatch(setSelectedColor(format['color']));
                    dispatch(setColorPickerColor(format['color']));
                } else {
                    dispatch(setSelectedColor('#000000'));
                    dispatch(setColorPickerColor('#000000'));
                }

                if (format['font']) {
                    dispatch(setSelectedFont(format['font']));
                } else {
                    dispatch(setSelectedFont('sans-serif'));
                }

                if (format['italic']) {
                    dispatch(setIsItalic(true));
                } else {
                    dispatch(setIsItalic(false));
                }

                if (format['list'] === 'ordered') {
                    dispatch(setIsOrderedList(true));
                } else {
                    dispatch(setIsOrderedList(false));
                }

                if (format['size']) {
                    if (format['size']?.includes('px')) {
                        dispatch(setSelectedSize(format['size']?.replace('px', '')));
                    } else if (format['size']?.includes('pt')) {
                        dispatch(setSelectedSize(ptToPx(parseInt(format['size']?.replace('pt', ''))).toString()));
                    }
                } else {
                    dispatch(setSelectedSize('15'));
                }

                if (format['strike']) {
                    dispatch(setIsStrike(true));
                } else {
                    dispatch(setIsStrike(false));
                }

                dispatch(setIsUnderline(!!format['underline']));

                if (format['list'] === 'bullet') {
                    dispatch(setIsUnorderedList(true));
                } else {
                    dispatch(setIsUnorderedList(false));
                }

                if (range) {
                    const existingLink = quill.getFormat(range.index, range.length).link;

                    if (!existingLink) {
                        dispatch(setBlotLinkAnchorEl(null));
                        dispatch(
                            setBlotDetails({
                                startingIndex: 0,
                                blotElementLength: 0,
                                blotElementText: '',
                                blotElementLink: '',
                            })
                        );
                        return;
                    }

                    const linkElement = window.document.querySelector(`a[href="${existingLink}"]`);

                    if (!linkElement) return;

                    const blotElement = quill.getLeaf(range.index)[0];
                    const startingIndex = quill.getIndex(blotElement);

                    const blotElementLength = blotElement.domNode.length;
                    const blotElementText = blotElement.domNode.textContent;

                    dispatch(setBlotLinkAnchorEl(linkElement));
                    dispatch(
                        setBlotDetails({
                            startingIndex,
                            blotElementLength,
                            blotElementText,
                            blotElementLink: existingLink,
                        })
                    );
                }
            }

            const debouncedHandleSelectionChange = debounce(handleSelectionChange, 500);

            quill.on('selection-change', debouncedHandleSelectionChange);

            return () => {
                quill.off('selection-change', debouncedHandleSelectionChange);
            };
        }
    }, [editorRef]);

    return (
        <div
            className={`flex items-center justify-between !border-b !border-[#F1F5F9] bg-white !px-6 !py-1 fixed z-10 w-full !top-[69px] ${
                isEditable ? '' : 'pointer-events-none saturate-0 cursor-none [&>div]:opacity-50'
            }`}
        >
            <div className="flex flex-1 items-center !gap-2 !py-2">
                {/* <TemplateTool editorRef={editorRef} templates={templates} />

                <div className="!w-px !h-7 bg-[#CBD5E1]" /> */}

                <FontTool editorRef={editorRef} />

                <div className="!w-px !h-7 bg-[#CBD5E1]" />

                <div className="flex items-center !gap-0.5">
                    <UndoTool editorRef={editorRef} />

                    <RedoTool editorRef={editorRef} />
                </div>

                <div className="!w-px !h-7 bg-[#CBD5E1]" />

                <SizeTool editorRef={editorRef} />

                <div className="!w-px !h-7 bg-[#CBD5E1]" />

                <AlignmentTool editorRef={editorRef} />

                <div className="!w-px !h-7 bg-[#CBD5E1]" />

                <ColorTool editorRef={editorRef} />

                <div className="!w-px !h-7 bg-[#CBD5E1]" />

                <div className="flex items-center !gap-0.5">
                    <BoldTool editorRef={editorRef} />

                    <ItalicTool editorRef={editorRef} />

                    <UnderlineTool editorRef={editorRef} />

                    <StrikeTool editorRef={editorRef} />

                    <CodeTool editorRef={editorRef} />

                    <BackgroundTool editorRef={editorRef} />
                </div>

                <div className="!w-px !h-7 bg-[#CBD5E1]" />

                <div className="flex items-center !gap-0.5">
                    <UnorderedListTool editorRef={editorRef} />

                    <OrderedListTool editorRef={editorRef} />

                    <DecreaseIndentTool editorRef={editorRef} />

                    <IncreaseIndentTool editorRef={editorRef} />
                </div>

                <div className="!w-px !h-7 bg-[#CBD5E1]" />

                <div className="flex items-center !gap-0.5">
                    <LinkToolbar editorRef={editorRef} />

                    <ImageTool editorRef={editorRef} />

                    <TableTool editorRef={editorRef} />

                    <CodeBlockTool editorRef={editorRef} />

                    <BlockquoteTool editorRef={editorRef} />

                    <ClearTool editorRef={editorRef} />
                </div>
            </div>

            <div className="flex items-center !gap-4 !py-1.5">
                <Profile document={document} isTemplateFile={isTemplateFile} />

                {/* <HistoryTool /> */}

                {/* <CommentTool editorRef={editorRef} /> */}
            </div>
        </div>
    );
}
